module.exports = __webpack_public_path__ + "static/button-mobile-elevation-do-aca5c5d915c1a10cc4a1926bc3322af1.png";